import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=756d95ac"
import script from "./MagicLink.vue?vue&type=script&lang=js"
export * from "./MagicLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports